import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Users, CreditCard, ChartLineUp, ChartBar, Megaphone, ClipboardText, ShieldStar, Sliders, Tag, Note, Buildings, Airplane, Bank } from "@phosphor-icons/react";

const tabs = [
  { to: "/admin/users", label: "Users", icon: Users, testId: "admin-tab-users" },
  { to: "/admin/subscriptions", label: "Subscriptions", icon: CreditCard, testId: "admin-tab-subscriptions" },
  { to: "/admin/revenue", label: "Revenue", icon: ChartLineUp, testId: "admin-tab-revenue" },
  { to: "/admin/analytics", label: "Analytics", icon: ChartBar, testId: "admin-tab-analytics" },
  { to: "/admin/platform", label: "Platform", icon: Sliders, testId: "admin-tab-platform" },
  { to: "/admin/promotions", label: "Promotions", icon: Tag, testId: "admin-tab-promotions" },
  { to: "/admin/content", label: "Content", icon: Note, testId: "admin-tab-content" },
  { to: "/admin/organizations", label: "Organizations", icon: Buildings, testId: "admin-tab-organizations" },
  { to: "/admin/leave", label: "Leave", icon: Airplane, testId: "admin-tab-leave" },
  { to: "/admin/tax", label: "Tax Centre", icon: Bank, testId: "admin-tab-tax" },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone, testId: "admin-tab-announcements" },
  { to: "/admin/audit", label: "Audit Log", icon: ClipboardText, testId: "admin-tab-audit" },
];

export default function AdminLayout() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  return (
    <div className="animate-fade-up" data-testid="admin-panel">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-10 w-10 rounded-md bg-destructive/15 flex items-center justify-center">
          <ShieldStar className="h-6 w-6 text-destructive" weight="fill" />
        </div>
        <div>
          <p className="overline text-destructive">Restricted</p>
          <h1 className="text-3xl font-black tracking-tight">Admin Panel</h1>
        </div>
      </div>

      <div className="flex flex-wrap gap-1.5 mb-6 border-b border-border pb-3 overflow-x-auto">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} data-testid={t.testId}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                isActive ? "bg-primary/15 text-primary" : "text-muted-foreground hover:text-foreground hover:bg-secondary/60"
              }`}>
            <t.icon className="h-4 w-4" weight="bold" /> {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
